import { useEffect, useState } from "react";

let available = true;
const listeners = new Set();

export function setSpanishAvailable(v) {
  const val = !!v;
  if (available === val) return;
  available = val;
  listeners.forEach((f) => f(available));
}

export function useSpanishAvailable() {
  const [v, setV] = useState(available);
  useEffect(() => {
    setV(available);
    listeners.add(setV);
    return () => listeners.delete(setV);
  }, []);
  return v;
}
